export const SET_UNRECONCILE_USERS = 'SET_UNRECONCILE_USERS';
export const SET_BATCHES = 'SET_BATCHES';
export const SET_SELECTED_BATCHES = 'SET_SELECTED_BATCHES'

const initialState = {
    users: [],
    batches: [],
    selectedBatches: [],
}

const UnreconcileReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_UNRECONCILE_USERS:
            return {
                ...state,
                users: action.users
            }
        case SET_SELECTED_BATCHES:
            return {
                ...state,
                selectedBatches : action.selectedBatches
            }
        case SET_BATCHES:
            return {
                ...state,
                batches: action.batches
            }    
        default:
            return state;
    }
}

export default UnreconcileReducer;